import React from "react";
import { Outlet } from "react-router-dom";

function userLoyalty() {
    return (
        <div>
            <Outlet />
        </div>
    );
}

export default userLoyalty;
